import {LocationDetectedVariant} from 'src/shared/types'

export const DEFAULT_CITIES: LocationDetectedVariant[] = [
  {
    address: 'Россия, Москва',
    geo_id: 213,
  },
  {
    address: 'Россия, Санкт-Петербург',
    geo_id: 2,
  },
  {
    address: 'Россия, Свердловская область, Екатеринбург',
    geo_id: 54,
  },
  {
    address: 'Россия, Республика Татарстан, Казань',
    geo_id: 43,
  },
]

export const DELAY_TIMEOUT_MS = process.env.NODE_ENV === 'development' ? 800 : 1000

export const NDD_PACKAGE_SIZES = {
  extraSmall: {
    height: 20,
    length: 26,
    weight: 1,
    width: 2,
  },
  small: {
    height: 15,
    length: 10,
    weight: 3,
    width: 25,
  },
  medium: {
    height: 25,
    length: 15,
    weight: 10,
    width: 35,
  },
  large: {
    height: 30,
    length: 20,
    weight: 30,
    width: 40,
  },
  extraLarge: {
    height: 40,
    length: 60,
    weight: 20,
    width: 45,
  },
  extraExtraLarge: {
    height: 24,
    length: 149,
    weight: 20,
    width: 24,
  },
} as const
